// src/pages/AboutPage.js
import React from 'react';
import '../styles/AboutPage.css';
import Footer from '../components/Footer';
import dish1 from '../assets/dish4.jpg';
import dish2 from '../assets/dish19.jpg';

const AboutPage = () => (
  <div className="about-page">

    {/* Hero banner */}
    <section className="about-hero">
      <div className="about-hero__bg" aria-hidden="true" />
      <div className="about-hero__content">
        <span className="about-hero__eyebrow">Our Story</span>
        <h1 className="about-hero__title">About Lebua Thai</h1>
      </div>
    </section>

    {/* Story section */}
    <section className="about-story">

      {/* Text blocks */}
      <div className="about-story__text">
        <div className="about-block">
          <span className="about-block__label">Who We Are</span>
          <hr className="about-block__divider" />
          <h2>A Passion for Authentic Thai Cuisine</h2>
          <p>
            Welcome to Lebua Thai, where the vibrant flavours of Thailand come to life
            in the heart of Singapore. Our journey began with a simple yet profound love
            for Thai cuisine and culture — a belief that food is more than sustenance.
            It is a bridge that connects people, traditions, and stories.
          </p>
        </div>

        <div className="about-block">
          <span className="about-block__label">Our Kitchen</span>
          <hr className="about-block__divider" />
          <h2>Crafted With Care, Cooked With Soul</h2>
          <p>
            Our chefs, trained in the art of Thai cooking, bring a wealth of experience
            and a passion for excellence to every plate. We source the finest ingredients —
            including fresh herbs and spices imported directly from Thailand — to ensure
            that every bite is as authentic as it is delicious.
          </p>
          <p style={{ marginTop: '1rem' }}>
            From our signature Pad Thai and Green Curry to our refreshing Som Tum and
            decadent Mango Sticky Rice, every dish is crafted to delight your senses and
            provide a true taste of Thailand.
          </p>
        </div>

        <div className="about-block">
          <span className="about-block__label">Our Promise</span>
          <hr className="about-block__divider" />
          <h2>Warm Hospitality, Every Visit</h2>
          <p>
            Whether you are joining us for a casual meal with friends, a family
            celebration, or a romantic dinner, our friendly staff is here to make your
            dining experience truly memorable. At Lebua Thai, you are always family.
          </p>
        </div>
      </div>

      {/* Image column */}
      <div className="about-story__images">
        <img
          src={dish1}
          alt="Signature dish at Lebua Thai"
          className="about-story__img"
          loading="lazy"
        />
        <img
          src={dish2}
          alt="Freshly prepared Thai cuisine"
          className="about-story__img about-story__img--tall"
          loading="lazy"
        />
      </div>
    </section>

    {/* Values strip */}
    <section className="about-values">
      <div className="about-values__inner">
        <div className="about-values__header">
          <span>What Drives Us</span>
          <h2>Our Values</h2>
          <hr className="gold-divider gold-divider--center" />
        </div>
        <div className="about-values__grid">
          <div className="value-card">
            <span className="value-card__icon" aria-hidden="true">🌿</span>
            <h3>Fresh Ingredients</h3>
            <p>Herbs and spices sourced directly from Thailand for an authentic flavour profile you can taste.</p>
          </div>
          <div className="value-card">
            <span className="value-card__icon" aria-hidden="true">🍽️</span>
            <h3>Authentic Recipes</h3>
            <p>Traditional cooking techniques passed down through generations, prepared with meticulous care.</p>
          </div>
          <div className="value-card">
            <span className="value-card__icon" aria-hidden="true">🤝</span>
            <h3>Warm Hospitality</h3>
            <p>Every guest is welcomed like family. We are here to make your experience unforgettable.</p>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
);

export default AboutPage;
